<div class="container-fluid" *ngIf="!routeCtrl.isNew">
  <div class="card border-light shadow-sm">
    <div class="row">
      <div style="margin-top:1%; margin-bottom:-5px; margin-left:10px">
        <h6>
          <span style="padding-right:5px"></span>
          <i class="fa fa-globe"></i>
          <b>Route </b> <span style="color:lightgray">
            <!-- <a class="red-asterik"> *</a> Please give a full description of your route -->
          </span>
        </h6>
      </div>
    </div>
    <form [formGroup]="form" (ngSubmit)="onSubmit(form.value)">
      <div class="col-md-12 p-0">
        <div class=" form-group ">

          <!-- <div *ngIf="checkDelete==false" class="row">
            <div class="col-sm-4 ">
              <input type="radio" formControlName="btnRadio" [(ngModel)]="routeCtrl.btnRadio"
                     [disabled]="!isProcess"
                     title="These are standard pre-defined CBRTA routes" name="btnRadio" value="1"
                     (change)="checkOption($event)" />
              <label>Standard Route</label>
            </div>
            <div class="col-sm-4 ">
              <input type="radio" formControlName="btnRadio" [(ngModel)]="routeCtrl.btnRadio"
                     [disabled]="!isProcess"
                     title="These are routes that you have used on previous permit applications" [checked]="isCheck"
                     name="btnRadio" value="2" (change)="checkOption($event)" />
              <label>Reuse a previous route</label>
            </div>
            <div class="col-sm-4 ">
              <input type="radio" formControlName="btnRadio"
                     [disabled]="!isProcess" [(ngModel)]="routeCtrl.btnRadio" [checked]="routeCtrl.btnRadio==3"
                     title="Create a new route from scratch" name="btnRadio" value="3" (change)="checkOption($event)" />
              <label>Create new route</label>
            </div>
          </div> -->

          <div *ngIf="routeCtrl.btnRadio=='1' || routeCtrl.btnRadio=='2' || routeCtrl.btnRadio=='3' || isCheck" class="row">
            <input type="hidden" formControlName="id" />
            <div class="col-sm-4 " *ngIf="routeCtrl.btnRadio!='3'">
              <!-- <label>Route Name</label> -->
              <!-- title="Enter a name for the route that is easy to remember (e.g. Harare to Joburg)" -->
              <select formControlName="route_name" *ngIf="isDuplicateMode"
                      [attr.disabled]="(isDuplicateMode || !isProcess||(isStandard && dataCntrl.application.route_id!=null)) ? true: null"
                      title="Select a route"
                      [(ngModel)]="selectedRoute" class="form-control form-control-sm" (change)="checked()">
                <option *ngIf="defaultValue == ''" disabled>Select route</option>
                <option *ngIf="defaultValue  != ''" disabled [value]="defaultValue">{{defaultValue}}</option>
                <ng-container *ngIf="isCheck==false">
                  <ng-container *ngFor="let r of routes">
                    <option *ngIf="r.is_active" [disabled]="isDuplicateMode" [ngValue]="r" selected="r.id == selectedRoute.id">{{r.description}}</option>
                  </ng-container>
                </ng-container>
                <ng-container *ngIf="isCheck==true">
                  <option *ngFor="let r of routes" [disabled]="isDuplicateMode" [ngValue]="r">{{r.description}}
                  </option>
                </ng-container>
              </select>
              <!-- title="Enter a name for the route that is easy to remember (e.g. Harare to Joburg)" -->
              <select formControlName="route_name" *ngIf="!isDuplicateMode"
                      [attr.disabled]="!isProcess ||(isStandard && dataCntrl.application.route_id!=null) || isLongTermCorrection? true: null"
                      title="Select a route"
                      [(ngModel)]="selectedRoute" class="form-control form-control-sm" (change)="checked()">
                <option *ngIf="defaultValue == ''" disabled>Select route</option>
                <option *ngIf="defaultValue  != ''" disabled [value]="defaultValue">{{defaultValue}}</option>
                <ng-container *ngIf="isCheck==false">
                  <ng-container *ngFor="let r of routes">
                    <option *ngIf="r.is_active" [ngValue]="r">{{r.description}}</option>
                  </ng-container>
                </ng-container>
                <ng-container *ngIf="isCheck==true">
                  <option *ngFor="let r of routes" [ngValue]="r">
                    {{r.description}}
                  </option>
                </ng-container>
              </select>
            </div>
            <!-- <div class="col-sm-4 " *ngIf="routeCtrl.btnRadio=='3'">
              <label>Route Name</label>
              <input formControlName="description" [disabled]="!isProcess || isStandard" [ngModel]="routeCtrl.rLeg.description"
                     title="Enter a name for the route that is easy to remember (e.g. Harare to Joburg)"
                     class="form-control form-control-sm" type="text" />
            </div> -->
            <!-- <div class="col-sm-4 ">
              <label>Description</label>
              <textarea formControlName="route_summary" [readonly]="isDuplicateMode || !isProcess || isStandard || isLongTermCorrection" [ngModel]="routeCtrl.rLeg.route_summary"
                        title="Enter a short description of the route (e.g. Harare to Joburg via Bulawayo)"
                        class="form-control form-control-sm" type="text"></textarea>
            </div>
            <div class="col-sm-4">
              <label>Code</label>
              <div class="form-inline">
                <input style="width:80%;" formControlName="code" maxlength="12" [readonly]=" isStandard || isDuplicateMode || !isProcess || isLongTermCorrection" [ngModel]="routeCtrl.rLeg.code"
                       title="Enter a unique identifier for this route (e.g. HREJHB01)" class="form-control form-control-sm"
                       type="text" />
                &nbsp;
                <i class="text-danger fa fa-trash" id="input_img" (click)="deleteRoute()" aria-hidden="true"
                   title="Delete the current route and start afresh." *ngIf="(checkDelete==true && !isDuplicateMode) && isProcess"></i>
              </div>
            </div> -->

          </div>
          <br>
          <div class="col-sm-12 p-0 mt-2" *ngIf="routeCtrl.btnRadio=='1' || routeCtrl.btnRadio=='2' || routeCtrl.btnRadio=='3' || isCheck">
            <label for="description" class="label-desc" *ngIf="frghtPass!='A'">Route Details (You can edit route details if necessary)</label>
            <label for="description" class="label-desc" *ngIf="frghtPass=='A'">Route Details</label>
            <p class="label-route" *ngIf="frghtPass!='A'">
              Enter a detailed description of the whole route, indicating all the stopping points
              and border posts (You can copy and paste from your word document.)
            </p>
            <ckeditor title="" [readonly]="isDuplicateMode || !isProcess || isStandard || !isStandard && frghtPass=='A' || isLongTermCorrection" formControlName="route_detail" (input)="changes()"
                      debounce="500" [ngModel]="routeCtrl.rLeg.route_detail">
            </ckeditor>
          </div>
        </div>



      </div>
    </form>
  </div>
  <!--<div class="card border-light shadow-sm">
    <app-app-motivation [dataCntrl]="dataCntrl"></app-app-motivation>
  </div>-->

  <div class="col-12" *ngIf="dataCntrl.status != 2 || isProcess">
    <div class="col-12" *ngIf="isProcess">
      <button class="btn btn-md m-clr pull-right hd-btn mt-2 ml-2" [disabled]="disableBtn" (click)="backToTab()"
              title="Back" style="float: left !important;">
        Back
      </button>
      <ng-container *ngIf="isProcess">
        <button class="btn btn-md m-clr pull-right hd-btn mt-2" [disabled]="disableBtn" (click)="cancelApplication()"
                title="Cancel" style="float: right !important;">
          Cancel
        </button>
        <button class="btn btn-md m-clr pull-right hd-btn mr-2 mt-2" (click)="saveRoute()" title="Save & Continueto step 4"
                [disabled]="disableBtn" style="float: right !important;">
          Save & Continue
        </button>
      </ng-container>
      <div *ngIf="disableBtn">
        <button class="btn btn-md m-clr pull-right hd-btn mr-2 mt-2" routerLink="/permit/approval" title="Cancel"
                style="float: right !important;">
          Back
        </button>
      </div>
    </div>
  </div>
</div>
  <!--Route type 13 & 15 management-->
  <div class="container-fluid" *ngIf="routeCtrl.isNew">
    <div class="card border-light shadow-sm">
      <app-add-route [routeCtrl]="routeCtrl"></app-add-route>
    </div>
  </div>
  <div class="col-12" *ngIf="pageload">
    <app-busy [message]="message"></app-busy>
  </div>

